import { Box, InputLabel, TextField } from "@mui/material";
import styles from './BaseInput.module.scss';
import classNames from 'classnames/bind';
import { getIn } from "formik";

const cx = classNames.bind(styles);

const BaseInput = (props: {
  name: string;
  title: string;
  form?: any;
  placeholder: string;
  inputkey: string;
  value?: string | number | null;
  disable?: boolean;
  inputType?: string;
  maxText?: number;
  unit?: string;
  onChange?: (e: any) => void;
  width?: string;
  restrictNumber?: boolean; 
  type?: string;
}) => {
  const {
    name,
    title,
    form,
    placeholder,
    inputkey,
    value,
    inputType = "text",
    maxText,
    unit,
    onChange,
    disable,
    width,
    restrictNumber,
    type,
  } = props;

  const errorMessage = getIn(form?.errors, inputkey);
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    let updatedValue = inputValue;

    if (restrictNumber) {
      updatedValue = inputValue.replace(/[^0-9]/g, "");
    }

    if (onChange) {
      onChange({ ...e, target: { ...e.target, value: updatedValue } });
    }

    if (form) {
      form.setFieldValue(inputkey, updatedValue);
    }
  };

  return (
    <Box className="w-full">
      {title && <InputLabel className={cx("form-input-title")}>{title}</InputLabel>}
      <Box
        className={cx(
          "box-form-input",
          {
            "box-form-input-unit": unit,
          },
          type && `box-form-input-${type}`
        )}
        style={{ width }}
      >
        <TextField
          className={cx(
            type && `box-form-input-${type}`,
            { "form-textarea": inputType === "textarea" },
            type && `form-input-${type}`
          )}
          fullWidth
          type={inputType}
          multiline={inputType == "textarea"}
          name={name}
          placeholder={placeholder}
          value={value !== undefined ? value : form?.values[inputkey]}
          onChange={handleInputChange}
          disabled={disable}
          error={Boolean(errorMessage)}
          helperText={errorMessage}
        />
      </Box>
    </Box>
  );
};

export default BaseInput;